<template>
  <div class="app-wrapper">
    <top-bar-static
      v-if="showStaticTopBar"
      ref="topBar"
    />

    <!--    <TopBarStaticFoodleap ref="topBar" v-else-if="showFoodleapHomepage"/>-->
    <TopBarStaticFoodleapNew ref="topBar" v-else-if="showFoodleapHomepage"/>
    <TopBarOpenCreatives ref="topBar" v-else-if="showOpenCreativesTopBar"/>
    <TopBarStaticAgritech ref="topBar" v-else-if="showAgritechHomepage"/>
    <TopBarStaticSpacewerx ref="topBar" v-else-if="showSpacewerxHomepage"/>
    <TopBarStaticCNZ ref="topBar" v-else-if="showNewZealandStaticHome"/>
    <TopBarStaticBrussels ref="topBar" v-else-if="showBrusselsHomepage"/>
    <TopBarBeciBrusselsVisitorsOnly ref="topBar" v-else-if="showBrusselsStaticTopBar"/>

    <top-bar
      v-else-if="!showKlikHomepage || !showOpenCreativesZuidwestHomepage || !showOpenCreativesWaaslandHomepage"
      :notifications="! isMobile"
      ref="topBar"
      @toggleMobileNavigationDrawerVisibility="handleToggleMobileNavigationDrawerVisibility"
      @toggleMobileSearchDrawerVisibility="handleToggleMobileSearchDrawerVisibility"
    />


    <SecondTopBar v-if="canShowSecondTopBar"/>
    <TopBarStaticBrussels v-if="showBrusselsSecondaryNav"/>
    <CallToActionTopBar v-if="canShowCallToActionTopBar"/>
    <TopBarStaticSamergo ref="topBar" v-if="showSamergoLoggedInTopBar"/>

    <MobileNavigationDrawer
      :isOpen="isMobileNavigationDrawerOpen"
      @close="closeMobileNavigationDrawer"
    />
    <MobileSearchDrawer
      :isOpen="isMobileSearchDrawerOpen"
      @close="isMobileSearchDrawerOpen = false"
    />
    <div
      class="viewport"
      :class="{
      'has-static-homepage': showStaticTopBar,
      'has-PnG-homepage': showPnGTopBar,
      'has-klik-homepage': showKlikHomepage,
      'has-foodleap-homepage': showFoodleapHomepage,
      'has-samergo-logged-in-homepage': showSamergoLoggedInTopBar,
'has-simplified-top-bar': canShowSecondTopBar || canShowCallToActionTopBar,
      'has-open-creatives-top-bar': showOpenCreativesTopBar,
      'has-simplified-top-bar-blurred': canShowSecondTopBar && hasBlurredSecondTopBar
    }"
    >
      <navigation v-if="shouldShowNavigation"/>
      <ecosystem-switcher/>
      <div class="main-view overflow-auto" :class="{'with-navigation': shouldShowNavigation}">
        <router-view ref="view"></router-view>
      </div>
      <subnav-home-links v-if="isActor && canShowHomeLinks"/>

      <ds-button
        icon="chevron-right" @click="switchPanelState" variant="secondary"
        size="small"
        :class="[subnavEnabled ? 'side-panel__collapse-button-collapsed' : 'side-panel__collapse-button-collapsed-fixed-right']"
        v-if="!isExpanded && typeOfPanel == 'edit-portfolio'"
      />
      <side-panel/>
    </div>
    <notifications
      group="alerts" class="pop-up__slot" position="bottom right"
      v-if="! isMobile"
    >
      <template #body="props">
        <div
          class="pop-up__wrapper" @click="goToNotification(props.item)"
          v-if="props.item.text"
        >
          <div class="pop-up__ribbon" :style="notificationColor(props.item.type)"></div>
          <div class="pop-up__notification">
            <icon
              class="pop-up__notification__icon"
              :class="notificationColorClass(props.item.type)"
              :name="notificationIconName(props.item.type, props.item.event)"
            ></icon>
            <div class="pop-up__title">{{ props.item.title }}</div>
            <icon class="pop-up__close" @click.stop="props.close" name="remove"/>
          </div>
        </div>
        <div div class="pop-up__wrapper" @click="goToNotification(props.item)" v-else>
          <div class="pop-up__all-notification">
            <div>{{ $t('message_click_here_to_see_all_notifications') }}</div>
          </div>
        </div>
      </template>
    </notifications>
    <SamergoFloatingChat v-if="showSamergoFloatingChat"/>
    <modals-container/>
    <policy-announcement-modal
      v-if="pendingPolicyAnnouncement && !isPolicyDocumentRoute"
      :announcement="pendingPolicyAnnouncement"
      @accepted="onPolicyAnnouncementAccepted"
    />
    <cookie-consent-modal/>
    <cookie-consent-preferences-modal/>
  </div>
</template>

<script>
  import TopBar from './components/TopBar/TopBar.vue'
  import SecondTopBar from './components/TopBar/SecondTopBar.vue'
  import CallToActionTopBar from './components/TopBar/CallToActionTopBar.vue'
  import TopBarStatic from './components/TopBar/TopBarStatic.vue'
  import Navigation from './components/Navigation/Navigation.vue'
  import SubnavHomeLinks from './components/Navigation/SubnavHomeLinks.vue'
  import EcosystemSwitcher from './components/EcosystemSwitcher/EcosystemSwitcher.vue'
  import SidePanel from './components/SidePanel/SidePanel.vue'
  import ModalsContainer from './components/Modals/ModalsContainer.vue'
  import PolicyAnnouncementModal from './components/Modals/PolicyAnnouncementModal.vue'
  import CookieConsentModal from './components/CookieConsent/CookieConsentModal.vue'
  import CookieConsentPreferencesModal from './components/CookieConsent/CookieConsentPreferencesModal.vue'
  import Icon from './components/Icon/Icon.vue'
  import HoverOverlayButton from './components/Overlay/HoverOverlayButton.vue'
  import MobileNavigationDrawer from './components/MobileNavigationDrawer/MobileNavigationDrawer.vue'
  import MobileSearchDrawer from './components/MobileSearchDrawer/MobileSearchDrawer.vue'
  import TopBarStaticCNZ from '@/components/TopBar/TopBarStaticCNZ.vue'
  import TopBarStaticSamergo from '@/components/TopBar/TopBarStaticSamergo.vue'
  import SamergoFloatingChat from '@/components/Samergo/SamergoFloatingChat.vue'

  import { notificationColor, notificationColorClass, notificationIconName } from './util/NotificationsMixin'
  import UiMixin from './util/UiMixin'
  import TranslationsMixin from './util/TranslationsMixin'

  import { MUTATION_TYPES as UI_MUTATION_TYPES } from './store/modules/ui'

  import { ACTION_TYPES as USER_ACTION_TYPES } from './store/modules/user.js'
  import { ACTION_TYPES as BOOT_ACTION_TYPES } from './store/modules/boot'
  import { ActionTypes as ConceptSearchesActionTypes } from './store/modules/concept-searches'

  import MODAL_IDS from './constants/modal-ids'

  import { trackHeapEvent } from './util/analytics.js'
  import { verifyCsrfToken } from './api/user.js'
  import { SiteTemplate } from './store/modules/config'
  import { DEFAULT_URLS } from './constants/default-urls.js'
  import { deferConsentDialog, hasDecided, onConsentChange, refreshConsent, releaseConsentDialog } from './util/cookie-consent'
  import { Policy } from '@/Domain/Policy/Enums/enums'
  import TopBarStaticBrussels from '@/components/TopBar/TopBarStaticBrussels.vue'
  import TopBarStaticFoodleap from './components/TopBar/TopBarStaticFoodleap.vue'
  import TopBarOpenCreatives from './components/TopBar/TopBarOpenCreatives.vue'
  import { ACTION_TYPES as LOCALIZATION_ACTION_TYPES, MUTATION_TYPES as LOCALIZATION_MUTATION_TYPES, } from './store/modules/localization'
  import TopBarStaticAgritech from '@/components/TopBar/TopBarStaticAgritech.vue'
  import TopBarStaticSpacewerx from '@/components/TopBar/TopBarStaticSpacewerx.vue'
  import TopBarBeciBrusselsVisitorsOnly from '@/components/TopBar/TopBarBeciBrusselsVisitorsOnly.vue'
  import { ACTION_TYPES as CONVERSATION_ACTION_TYPES } from '@/store/modules/conversations'
  import { ConversationsMixin } from '@/util/ConversationsMixin'
  import TopBarStaticFoodleapNew from '@/components/TopBar/TopBarStaticFoodleapNew.vue'

  export default {
    name: 'app',
    data () {
      return {
        isMobileNavigationDrawerOpen: false,
        isMobileSearchDrawerOpen: false,
        pendingPolicyAnnouncement: null,
      }
    },
    computed: {
      isCommunityEcosystem () {
        return this.$store.getters.isCommunityEcosystem
      },
      isPolicyDocumentRoute () {
        return ['terms-of-use', 'privacy-policy', 'cookie-policy'].includes(this.$route.name)
      },
      shouldShowNavigation () {
        const routesWithoutNavigation = ['addActor', 'login', 'restricted', 'forgot-password', 'gdpr-terms', 'change-password']
        const routesWithoutNavigationWhenOnboardingIsEnabled = ['addActor', 'login', 'restricted', 'forgot-password', 'gdpr-terms', 'change-password', 'sign-up', 'log-in']

        if (this.showKlikHomepage || this.showAriadneHomepage || this.showFoodleapHomepage || this.showBrusselsHomepage) {
          return false
        }

        if (this.$store.getters.isActor && [SiteTemplate.NEW_SIMPLIFIED, SiteTemplate.SIMPLIFIED].includes(this.$store.getters.activeSiteTemplate)) {
          return false
        }

        if (this.$store.getters.isPortfolioMember && [SiteTemplate.NEW_SIMPLIFIED, SiteTemplate.SIMPLIFIED].includes(this.$store.getters.activeSiteTemplate)) {
          return false
        }

        if (!this.$store.getters.isLoggedIn && [SiteTemplate.NEW_SIMPLIFIED, SiteTemplate.SIMPLIFIED].includes(this.$store.getters.activeSiteTemplate)) {
          return false
        }

        if (this.$route.name === 'spotting-areas' && !this.$store.state.ui.navigation.isVisible) {
          return false
        }

        return !routesWithoutNavigationWhenOnboardingIsEnabled.includes(this.$route.name)
      },
      hasBlurredSecondTopBar () {
        return false
      },
      canShowSecondTopBar () {
        return !this.showKlikHomepage &&
          !this.showOpenCreativesZuidwestHomepage &&
          !this.showOpenCreativesWaaslandHomepage &&
          !this.showSamergoHomepage &&
          !this.showSamergoLoggedInTopBar &&
          !this.showPnGTopBar &&
          //!this.showAriadneHomepage &&
          !this.showFoodleapHomepage &&
          !this.showBrusselsHomepage &&
          !this.showAgritechHomepage &&
          this.canShowBreadcrumbs &&
          !this.canShowCallToActionTopBar &&
          !this.showNewZealandStaticHome
      },
      canShowCallToActionTopBar () {
        return !this.$store.getters.isLoggedIn && this.isCommunityEcosystem && this.$route.path.startsWith('/dashboards/home')
      },
      isNewSimplified () {
        return this.config.siteTemplate === SiteTemplate.NEW_SIMPLIFIED
      },
      showKlikHomepage () {
        return this.$store.getters.isKlik && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showOpenCreativesZuidwestHomepage () {
        return this.$store.getters.isOpenCreativesZuidwest && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showOpenCreativesWaaslandHomepage () {
        return this.$store.getters.isOpenCreativesWaasland && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showSamergoHomepage () {
        return this.$store.getters.isSamergo && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showSamergoLoggedInTopBar () {
        return this.$store.getters.isSamergo && this.$store.getters.isLoggedIn
      },
      showSamergoFloatingChat () {
        // Floating chat on Samergo pages, except the home page which already has the inline hero chat + add-FAB
        return this.showSamergoLoggedInTopBar && !this.$route.path.startsWith('/dashboards/home')
      },
      showAriadneHomepage () {
        return this.$store.getters.isAriadne && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showFoodleapHomepage () {
        return this.$store.getters.isFoodleap && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && (this.$route.path.startsWith('/dashboards/home') || this.$route.path.startsWith('/dashboards/about') || this.$route.path.startsWith('/transitions') || this.$route.path.startsWith('/facilities') || this.$route.path.startsWith('/intelligence') || this.$route.path.startsWith('/about') || this.$route.path.startsWith('/transition-pulse-report') || this.$route.path.startsWith('/innovation-radar-report') || this.$route.path.startsWith('/deep-dive-report') || this.$route.path.startsWith('/open-innovation') || this.$route.path.startsWith('/advisory'))
      },
      showAgritechHomepage () {
        return this.$store.getters.isAgriTech && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showSpacewerxHomepage () {
        return this.$store.getters.isSpacewerx && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showNewZealandStaticHome () {
        return this.$store.getters.isCNZEcosystem && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      /*showBrusselsHomepage () {
        return [this.$store.getters.isBrussels || this.$store.getters.isLocal] && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },*/
      showBrusselsHomepage () {
        return this.$store.getters.isBrussels && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && (
          this.$route.path.startsWith('/dashboards/home') ||
          this.$route.path.startsWith('/directory-brussels') ||
          this.$route.path.startsWith('/hubs-brussels') ||
          this.$route.path.startsWith('/partners-brussels') ||
          this.$route.path.startsWith('/insights-brussels') ||
          this.$route.path.startsWith('/about-brussels') ||
          this.$route.path.startsWith('/journeys-brussels') ||
          this.$route.path.startsWith('/hubs-overview-brussels') ||
          this.$route.path.startsWith('/events-brussels')
        )
      },
      showBrusselsStaticTopBar () {
        return this.$store.getters.isBrussels && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous && this.$route.path.startsWith('/dashboards/home')
      },
      showBrusselsSecondaryNav () {
        return this.$store.getters.isBrussels && this.$store.getters.isLoggedIn && (
          this.$route.path.startsWith('/dashboards/home') ||
          this.$route.path.startsWith('/directory-brussels') ||
          this.$route.path.startsWith('/hubs-brussels') ||
          this.$route.path.startsWith('/partners-brussels') ||
          this.$route.path.startsWith('/insights-brussels') ||
          this.$route.path.startsWith('/about-brussels') ||
          this.$route.path.startsWith('/journeys-brussels') ||
          this.$route.path.startsWith('/hubs-overview-brussels') ||
          this.$route.path.startsWith('/events-brussels')
        )
      },
      config () {
        return this.$store.state.config
      },
      cookiePolicyUrl () {
        return this.config.cookiePolicyUrl || DEFAULT_URLS.COOKIE_POLICY
      },
      canOnlyCreateProducts () {
        return this.$store.getters.claimableActorTypes.includes('Product') && this.$store.getters.claimableActorTypes.length === 1
      },
      currentActivePage () {
        return this.$route.name
      },
      isMobile () {
        return this.$store.getters.isMobile
      },
      subnavEnabled () {
        return this.$store.getters.isOwner || this.$store.getters.isDeveloper
      },
      userCanCreate () {
        return this.$store.getters.userCanCreate
      },
      isProductEnabled () {
        return this.$store.getters.viewActorTypes.includes('Product')
      },
      isRouteThatAllowsUpgrade () {
        const allowedRoutes = ['/dashboards/home', '/actors-simplified', '/products-simplified', '/intelligence-simplified', '/actors']

        for (const route of allowedRoutes) {
          if (this.$route.path.startsWith(route)) {
            return true
          }
        }

        return false
      },
      isExplorationOnly () {
        return this.$store.getters.isExplorationOnly
      },
      isOnProductPage () {
        return this.$route.name === 'actor-detail' && this.$store.getters.detailActor && this.$store.getters.detailActor['actor_type'] === 'Product'
      },
      typeOfPanel () {
        return this.$store.state.ui.sidePanel.selectedComponent
      },
      isExpanded () {
        return this.$store.state.ui.sidePanel.expanded
      },
      isActor () {
        // To verify if the user is an ecosystem member
        return this.$store.getters.isActor
      },
      isMember () {
        return this.$store.getters.isMember
      },
      actorDetail () {
        return this.$store.getters.detailActor
      },
      homeLinks () {
        return window.config.homeLinks || []
      },
      canShowHomeLinks () {
        var hasHomeLinks = false

        this.homeLinks.forEach(item => {
          if (item.url && item.url.length > 0 && item.url !== ' ') {
            hasHomeLinks = true
          }
        })

        // The homelinks sub navigation should not be displayed on the home dashboard
        return hasHomeLinks && !this.$route.path.startsWith('/dashboards/home') && ![SiteTemplate.NEW_SIMPLIFIED, SiteTemplate.SIMPLIFIED].includes(this.$store.state.config.siteTemplate)
      },
      showPnGTopBar () {
        return this.$store.getters.isPnG && !this.$store.getters.isLoggedIn
      },
      showStaticTopBar () {
        return (this.$store.getters.isAriadne || this.$store.getters.isPnG) && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous
      },
      isFoodleap () {
        return this.$store.getters.isFoodleap
      },
      showOpenCreativesTopBar () {
        return (this.$store.getters.isKlik || this.$store.getters.isOpenCreativesZuidwest || this.$store.getters.isOpenCreativesWaasland) && !this.$store.getters.isLoggedIn && this.$store.state.config.allow_anonymous
      },
    },
    methods: {
      resolvePendingPolicyAnnouncement () {
        if (!this.$store.getters.isLoggedIn) {
          return
        }

        // Hold the banner back until we know whether an announcement is due.
        // Answering it in the meantime settles the cookie policy on its own,
        // and the announcement would then be shown having already lost the
        // right to a decision it never asked for. Every path out of
        // `applyPendingPolicyAnnouncement` either keeps the screen or gives it
        // back, and a failed lookup gives it back too — the banner is not
        // dismissable, so it must never be left held.
        if (!hasDecided()) {
          deferConsentDialog()
        }

        import('@/Domain/Policy/Api/announcements')
          .then(({ fetchPending }) => fetchPending()
            .then(response => this.applyPendingPolicyAnnouncement(response.data)))
          .catch(() => releaseConsentDialog())
      },
      /**
       * Decide which of the two blocking dialogs gets the screen. Both can be
       * about the cookie policy, and the visitor must never be handed the two
       * of them at once.
       */
      applyPendingPolicyAnnouncement (announcement) {
        if (!announcement) {
          this.pendingPolicyAnnouncement = null
          releaseConsentDialog()

          return
        }

        // An announcement carrying nothing but the cookie policy asks for what
        // the consent banner is about to ask for anyway, so the banner goes
        // first and this is dropped: an affirmative choice records the
        // acceptance, which settles the announcement along with it.
        if (this.isCookiePolicyOnlyAnnouncement(announcement) && !hasDecided()) {
          this.pendingPolicyAnnouncement = null
          releaseConsentDialog()

          return
        }

        // Anything else has to be acknowledged whatever the visitor decides
        // about cookies, so it takes the screen and the banner waits behind it.
        this.pendingPolicyAnnouncement = announcement

        if (!hasDecided()) {
          deferConsentDialog()
        }
      },
      isCookiePolicyOnlyAnnouncement (announcement) {
        const policies = announcement.linked_policies || []

        return policies.length > 0 && policies.every(policy => policy.type === Policy.cookiePolicy)
      },
      onPolicyAnnouncementAccepted () {
        this.pendingPolicyAnnouncement = null

        // An announcement carrying the cookie policy has just had the safe
        // default written for it server-side, so adopt that before handing the
        // screen back: otherwise the banner returns to ask what was settled.
        refreshConsent()
          .catch(() => {})
          .finally(() => releaseConsentDialog())
      },
      handleVisibilityChange () {
        if (document.visibilityState === 'visible') {
          this.checkSession();
        }
      },
      async checkSession () {
        if (this.$store.getters.isLoggedIn) {
          verifyCsrfToken()
            .then((response) => {
            })
            .catch((error) => {
              this.$router.push('/login')
            })
        }
      },
      handleToggleMobileNavigationDrawerVisibility () {
        this.isMobileNavigationDrawerOpen = !this.isMobileNavigationDrawerOpen
        this.isMobileSearchDrawerOpen = false
      },
      handleToggleMobileSearchDrawerVisibility () {
        this.isMobileSearchDrawerOpen = !this.isMobileSearchDrawerOpen
        this.isMobileNavigationDrawerOpen = false
      },
      notificationColor,
      notificationColorClass,
      notificationIconName,
      switchPanelState () {
        this.$store.commit(UI_MUTATION_TYPES.TOGGLE_SIDE_PANEL, true)
      },
      goToNotification (notification) {
        this.$notify({
          clean: true,
          group: 'alerts',
        })

        if (notification.text.startsWith('http')) {
          window.location.href = notification.text
        }

        if (!notification.text) {
          this.$router.push('/notifications')
        } else {
          this.$router.push(`/notifications/${notification.text}`)
        }
      },
      goToCreatePage (destination, tab, meta) {
        switch (destination) {
          case 'member':
            this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, { afterCreate: this.isMember ? 'addMore' : 'goToActor' })
            this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ADD_ACTOR)
            break
          case 'create-portfolio':
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, { component: 'create-portfolio' })
            break
          case 'create-challenge':
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
              component: 'manage-challenge-panel',
              metaData: meta,
            })
            break
          case 'create-resource':
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
              component: 'create-resource-panel',
              metaData: meta,
            })
            break
          case 'actor-edit':
            var params = { id: this.actorDetail.id }
            // If the tab parameter is not undefined, we send it in order to be able to open the correct tab on the actor edit sid panel
            if (tab) {
              params = Object.assign(params, { openTab: tab })
            }
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
              component: 'actor-edit',
              metaData: params,
            })
            break
          case 'edit-connections':
            this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
              component: 'actor-connections-panel',
            })
            break
          case 'add-product':
            this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, meta.modalContext)
            this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ADD_ACTOR)
            break
          default:
            this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, { afterCreate: this.isMember ? 'addMore' : 'goToActor' })
            this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.ADD_ACTOR)
            break
        }
      },
      closeMobileNavigationDrawer () {
        this.isMobileNavigationDrawerOpen = false
      },
    },
    created () {
      // Before the children render, so the consent banner is held back rather
      // than mounted and then withdrawn: a decision taken between the two
      // would settle the cookie policy behind the announcement's back.
      this.resolvePendingPolicyAnnouncement()

      if (this.$store.getters.isLoggedIn) {
        setTimeout(() => {
          this.$store.dispatch(ConceptSearchesActionTypes.FETCH_ALL_CONCEPT_SEARCHES)
        }, 3000)
      }
    },
    beforeDestroy () {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    mounted () {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      // Show offline modal if ecosystem is offline
      if (window.showOfflineModal) {
        this.$nextTick(() => {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.OFFLINE);
        });
      }

      this.$bus.on('showGlobalSearch', (value) => {
        this.$store.commit(UI_MUTATION_TYPES.SHOW_GLOBAL_SEARCH)
        // The search input may be lazily rendered (e.g. the collapsible top bar search),
        // so wait for the next tick and guard against missing refs.
        this.$nextTick(() => {
          this.$refs.topBar?.$refs?.globalSearch?.$refs?.searchInput?.focus()
        })
      })

      trackHeapEvent('session.start')
      window.addEventListener('beforeunload', () => {
        trackHeapEvent('session.end')
      })


      // Single boot request replaces individual calls for relationships,
      // spotting area highlight, communities, and spotting areas
      if (this.$store.getters.isPublic || this.$store.getters.isLoggedIn) {
        this.$store.dispatch(BOOT_ACTION_TYPES.FETCH_BOOT_DATA)
      }

      // A cookie-policy-only announcement is held back until the visitor has
      // answered the consent banner, so look again once they have: an
      // affirmative choice records the acceptance server-side and the
      // announcement is already settled, a refusal leaves it outstanding and it
      // is then shown on its own.
      let hadConsentDecision = hasDecided()

      this.stopWatchingConsent = onConsentChange(() => {
        if (hadConsentDecision || !hasDecided()) {
          return
        }

        hadConsentDecision = true
        this.resolvePendingPolicyAnnouncement()
      })

      if (this.$store.getters.hasAccessToEcosystemMemberPackages && this.$store.getters.isLoggedIn && this.$store.getters.userRole === 'actor') {
        if (!this.$store.state.user.fetchPackageSubscriptionPromise) {
          this.$store.dispatch(USER_ACTION_TYPES.FETCH_PACKAGE_SUBSCRIPTION)
        }

        /*this.$store.state.user.fetchPackageSubscriptionPromise.then(() => {
          if (this.$store.getters.isActor && (!this.$store.state.user.profile.subscriptionInfo || !this.$store.state.user.profile.subscriptionInfo.package)) {
            if (window.location.href.includes('/profile/subscription')) {
              return
            }

            // Make sure to sync this value with the hook in index.ts where we check
            window.location.href = '/profile/subscription'

            // The flow below is the deprecated flow where a user can choose on the homepage which package it needs and cannot view the app without it
            // The new flow is that a user needs to choose a package within the "upgrade" profile environment where all subscription related info is shown
            //this.$router.push('/dashboards/home')
            /*this.$store.commit(UI_MUTATION_TYPES.SET_MODAL_CONTEXT, { selectedPackage: null })
            this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.CONFIRM_PACKAGE)*/
        /*} else {
          console.log(this.$store.state.user)
        }
      })*/
      }

      this.$bus.on('toggleMobileSearchDrawerVisibility', () => {
        this.isMobileSearchDrawerOpen = !this.isMobileSearchDrawerOpen
        this.isMobileNavigationDrawerOpen = false
      })

      if (this.showOpenCreativesTopBar) {
        let locale = this.$store.getters.activeLocale
        if (!this.$store.getters.isLoggedIn) {
          locale = 'nl'
        }

        this.$store.dispatch(LOCALIZATION_ACTION_TYPES.UPDATE_ACTIVE_LOCALE, { locale: locale, i18n: this.$i18n })
      }

      if (document.querySelector('.global-search')) {
        document.querySelector('.global-search').style.transition = 'easein 300ms'
        document.querySelector('.global-search').style.opacity = 1
      }

      this.$store.commit(LOCALIZATION_MUTATION_TYPES.SET_ACTIVE_LOCALE, {
        locale: this.$store.getters.activeLocale,
        i18n: this.$i18n,
      })

      if (!this.hasAccessToConversations) {
        return
      }

      if (this.$store.getters.isLoggedIn && !this.$store.getters.isMobile) {
        let counter = 0
        setTimeout(() => {
          // We have a wide variety of API calls made when loading the app, this call can be held off for a while
          this.$store.dispatch(CONVERSATION_ACTION_TYPES.FETCH_CONVERSATIONS_UNREAD_COUNT)
        }, 10000)

        setInterval(() => {
          // Refresh only every 2 minutes if the document is hidden
          counter++
          if (document.hidden && counter % 6) {
            return
          }
          this.$store.dispatch(CONVERSATION_ACTION_TYPES.FETCH_CONVERSATIONS_UNREAD_COUNT).then(() => {
            if (this.unreadCount !== this.$store.state.conversations.listData.unreadCount) {
              this.unreadCount = this.$store.state.conversations.listData.unreadCount
              this.$store.dispatch(CONVERSATION_ACTION_TYPES.FETCH_CONVERSATIONS_LIST)
            }
          })
        }, 120000)
      }
    },
    watch: {
      subnavEnabled (val, old) {
        if (val && !old) {
          this.$root.collapsable.nav = true
        }
      },
      '$route.path' () {
        this.isMobileNavigationDrawerOpen = false
        this.isMobileSearchDrawerOpen = false
      },
    },
    beforeUnmount () {
      trackHeapEvent('pageExit', { to: 'close_tab' })
      this.stopWatchingConsent?.()
      this.$bus.off('toggleMobileSearchDrawerVisibility')
      this.$bus.off('showGlobalSearch')
    },
    mixins: [UiMixin, TranslationsMixin, ConversationsMixin],
    components: {
      CookieConsentModal,
      CookieConsentPreferencesModal,
      TopBarStaticBrussels,
      TopBarBeciBrusselsVisitorsOnly,
      TopBarStaticCNZ,
      TopBarStaticSamergo,
      SamergoFloatingChat,
      TopBarStaticSpacewerx,
      TopBarStaticAgritech,
      TopBarStaticFoodleap,
      TopBarStaticFoodleapNew,
      TopBarOpenCreatives,
      SecondTopBar,
      CallToActionTopBar,
      MobileNavigationDrawer,
      MobileSearchDrawer,
      TopBar,
      TopBarStatic,
      Navigation,
      SubnavHomeLinks,
      EcosystemSwitcher,
      ModalsContainer,
      PolicyAnnouncementModal,
      Icon,
      SidePanel,
      HoverOverlayButton,
    },
  }
</script>
<style lang="scss">
  @import "../scss/_variables.scss";

  .mobile__logo {
    padding: 15px;
    margin: auto;

    img {
      width: 100%;
      max-width: 190px;
    }
  }

  .mobile__title {
    align-items: center;
    padding-left: 15px;
    font-size: 21px;
    font-family: 'Sofia Pro', 'Roboto', sans-serif;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 500;
    margin-bottom: 25px;
  }

  .mobile__tagline {
    text-transform: capitalize;
    font-family: 'Fira Sans', sans-serif;
    line-height: 1.5em;
    font-size: 1.25em;
    letter-spacing: 2px;
    padding-bottom: 15px;
    padding-left: 15px;
  }

  .mobile__cta {
    margin: auto !important;
    display: block !important;
    margin-bottom: 25px !important;
  }

  .mobile__description {
    line-height: 1em;
    font-size: 1em;
    font-family: 'Fira Sans', sans-serif;
    letter-spacing: 2px;
    padding-bottom: 15px;
    padding-left: 15px;
  }

  $pop-up-height: 40px;

  .pop-up__notification {
    display: block;
    width: 270px;
    height: $pop-up-height;
    color: white;
    text-decoration: inherit;
    outline: none;
    background-color: $color-secondary;

    &:hover {

    }

    &:focus {
      position: relative;
      z-index: 1;
      box-shadow: 0 0 0 2px $color-primary;
    }
  }

  .pop-up__all-notification {
    background-color: $color-secondary;
    color: white;
    display: block;
    height: $pop-up-height;
    line-height: 40px;
    outline: none;
    overflow: unset;
    text-align: center;
    text-decoration: inherit;
    width: 270px;
  }

  .pop-up__notification__icon {
    float: left;
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-left: 15px;
    margin-top: 10px;
  }

  .pop-up__notification__content {
    margin-left: 5px;
    height: $pop-up-height;
  }

  .pop-up__title {
    width: 190px;
    display: inline-block;
    margin-left: 5px;
    margin-top: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .pop-up__ribbon {
    width: 5px;
    height: $pop-up-height;
    display: inline-block;
    position: absolute;
    left: 0;
  }

  .pop-up__close {
    cursor: pointer;

    .stroke-fg {
      stroke: $color-background-light-grey;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }

  .pop-up__ribbon-after {
    position: relative;
    z-index: 5;
  }

  .pop-up__wrapper {
    cursor: pointer;
    margin-bottom: 5px;
  }

  .pop-up__slot {
    margin-bottom: 50px;
  }

  .topbar-fade-enter-active,
  .topbar-fade-leave-active {
    transition: opacity 0.2s ease;
  }

  .topbar-fade-enter-from,
  .topbar-fade-leave-to {
    opacity: 0;
  }

  .application-plus-btn {
    right: 72px !important;
    bottom: 50px;
  }

</style>
